import { jsx as i } from "react/jsx-runtime";
import { memo as f } from "react";
import { getEntryStatusAbbrv as m } from "../utils.es.js";
import { statusLabel as a } from "./SeedStatus.styles.es.js";
const c = ({
  seed: t,
  status: r,
  showStatus: o
}) => {
  const e = t === "~" ? void 0 : t, n = e && r && o ? `[${e}/${m(r) || ""}]` : e ? `[${e}]` : r && o ? `[${m(r)}]` : "";
  return /* @__PURE__ */ i("p", { className: a(), children: n });
}, s = f(c);
export {
  s as default
};
//# sourceMappingURL=SeedStatus.es.js.map
